import tinycolor from 'tinycolor2';

const getDarkerColor = (color: string, lightenValue = 0.1) => {
  const { h, s, l } = tinycolor(color).toHsl();

  return tinycolor(`hsl(${h}, ${s}, ${l - lightenValue})`).toHexString();
};

export default getDarkerColor;
